import { Component, OnInit, Input } from '@angular/core';
import { ModalQuestionComponent } from '../modal-question/modal-question.component';

declare var $: any;

@Component({
  selector: 'stg-modal-marker',
  templateUrl: './modal-marker.component.html',
  styleUrls: ['./modal-marker.component.scss']
})
export class ModalMarkerComponent implements OnInit {

  @Input() title = 'Tytuł';
  @Input() description = 'Opis';
  @Input() photoUrl = '../../../assets/images/nysa/herb_nysa.png';

  shwoModalQuestion() {
    
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/shared-components/modal-marker/modal-marker.component.ts